import { EmptyState } from "src/components/EmptyState/EmptyState.tsx";
import { ButtonV2 } from "src/components/ButtonV2/ButtonV2.tsx";
import { useErrorBoundary } from "react-error-boundary";
import { css } from "@emotion/react";

export function B2bCatalogErrorBoundary() {
  const { resetBoundary } = useErrorBoundary();
  return (
    <div css={rootStyle}>
      <EmptyState
        type={"warning"}
        title={"Something went wrong"}
        description={"Try resetting the error"}
        action={
          <ButtonV2 variant={"filled"} onClick={resetBoundary}>
            Reset error
          </ButtonV2>
        }
      />
    </div>
  );
}

const rootStyle = css({
  display: "flex",
  height: "100%",
  alignItems: "center",
  justifyContent: "center",
});
